import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-double-down', 'ChevronDoubleDown', [["path",{"d":"m6 6 6 6 6-6M6 12l6 6 6-6","key":"svg-0"}]]);